import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  MatchNote,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';

const MATCH_NOTE_FIELDS = gql`
  fragment MatchNoteFields on MatchNote {
    id
    tournamentId
    matchId
    round
    tableNumber
    judgeId
    content
    createdAt
    judge {
      id
      name
      lastName
    }
    match {
      id
      round
      tableNumber
    }
  }
`;

export const getMatchNotes = async (
  user: UserWithToken,
  matchId: number
) =>
  getGraphQLQueryClient(user).request<WithData<MatchNote[]>>(
    gql`
      ${MATCH_NOTE_FIELDS}
      query matchNotes($matchId: Int!) {
        data: matchNotes(matchId: $matchId) {
          ...MatchNoteFields
        }
      }
    `,
    { matchId }
  );

export type AddTournamentNoteInput = {
  tournamentId: number;
  content: string;
  round?: number;
  tableNumber?: number;
};

export const addTournamentNote = async (
  user: UserWithToken,
  input: AddTournamentNoteInput
) =>
  getGraphQLQueryClient(user).request<WithData<MatchNote>>(
    gql`
      ${MATCH_NOTE_FIELDS}
      mutation addTournamentNote($input: AddTournamentNoteInput!) {
        data: addTournamentNote(input: $input) {
          ...MatchNoteFields
        }
      }
    `,
    { input }
  );

export const getTournamentNotes = async (
  user: UserWithToken,
  tournamentId: number,
  round?: number
) =>
  getGraphQLQueryClient(user).request<WithData<MatchNote[]>>(
    gql`
      ${MATCH_NOTE_FIELDS}
      query tournamentNotes($tournamentId: Int!, $round: Int) {
        data: tournamentNotes(tournamentId: $tournamentId, round: $round) {
          ...MatchNoteFields
        }
      }
    `,
    { tournamentId, round: round ?? null }
  );

export const addMatchNote = async (
  user: UserWithToken,
  matchId: number,
  content: string
) =>
  getGraphQLQueryClient(user).request<WithData<MatchNote>>(
    gql`
      ${MATCH_NOTE_FIELDS}
      mutation addMatchNote($matchId: Int!, $content: String!) {
        data: addMatchNote(matchId: $matchId, content: $content) {
          ...MatchNoteFields
        }
      }
    `,
    { matchId, content }
  );

export const updateMatchNote = async (
  user: UserWithToken,
  noteId: number,
  content: string
) =>
  getGraphQLQueryClient(user).request<WithData<MatchNote>>(
    gql`
      ${MATCH_NOTE_FIELDS}
      mutation updateMatchNote($noteId: Int!, $content: String!) {
        data: updateMatchNote(noteId: $noteId, content: $content) {
          ...MatchNoteFields
        }
      }
    `,
    { noteId, content }
  );

export const deleteMatchNote = async (
  user: UserWithToken,
  noteId: number
) =>
  getGraphQLQueryClient(user).request<WithData<boolean>>(
    gql`
      mutation deleteMatchNote($noteId: Int!) {
        data: deleteMatchNote(noteId: $noteId)
      }
    `,
    { noteId }
  );
